var render = function render(){var _vm=this,_c=_vm._self._c;return _c('orders-page',{attrs:{"title":"Past Orders","show-date-filter":true,"include-completed-orders":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }